import { render, staticRenderFns } from "./Presentations.vue?vue&type=template&id=1795a400&scoped=true&"
import script from "./Presentations.vue?vue&type=script&lang=js&"
export * from "./Presentations.vue?vue&type=script&lang=js&"
import style0 from "./Presentations.vue?vue&type=style&index=0&id=1795a400&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1795a400",
  null
  
)

export default component.exports